import React from "react";

import { HeadingLabel as Heading, NormalLabel as Label } from "@sisuwellness/ui/src/components/Labels";
import { Box, Card, Flex, Image } from "rebass";
import { PORTAL_IMAGE } from "constants/imagePath";
import { SecondaryButton } from "@sisuwellness/ui/src/components/Buttons";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { userIsBupaCustomer, userIsVhiCustomer } from "utilities/clientCheck";
import { useSelector } from "react-redux";

const EmptyState = ({ gender, history, theme }) => {
    const { t } = useTranslation();
    const { citizen } = useSelector(state => state.auth);

    return (
        <>
            <Label fs={15} mt="16px" fontWeight="normal">
                {t("members_portal_web.views.recommendations.empty.heading")}
            </Label>
            <Card
                px={["16px", "32px"]}
                pt="24px"
                pb={["80px", "40px", "32px"]}
                bg={theme.portalColor.hpCardBackground.hex}
                width="unset"
                mt={["24px", "48px"]}
                mb={["0", "223px"]}
            >
                <Flex alignItems={["start", "center"]}>
                    <Image
                        src={`${PORTAL_IMAGE}/healthHub/` + gender.toLowerCase() + `.svg`}
                        width={["75px", "120px"]}
                        height={["75px !important", "150px !important"]}
                        alt="avatar-logo"
                        mr={["30px", "50px"]}
                    />
                    <Box width="70%">
                        <Heading mb="10px" fontSize={["20px", "22px"]} lineHeight={["1.14", "1.15"]}>
                            {t("members_portal_web.views.recommendations.empty.no_assessments")}
                        </Heading>
                        <Flex flexDirection={["column", "column", "row"]} height={["39px", "49px"]} mt="20px">
                            <SecondaryButton
                                width={["208px", "auto", "272px"]}
                                height="100%"
                                backgroundColor="transparent"
                                borderColor={theme.colours.hpPrimaryPurple.hex}
                                color={theme.colours.hpPrimaryPurple.hex}
                                mr="20px"
                                mb={["24px", "5px", 0]}
                                onClick={() => history.push("/health-risk-onboarding")}
                                p={["8px 11px 11px 11px", "4px 11px 7px 11px"]}
                                fontSize={["15px"]}
                            >
                                {t("members_portal_web.views.recommendations.empty.take_assessment")}
                            </SecondaryButton>

                            {!userIsVhiCustomer(citizen) && !userIsBupaCustomer(citizen) && (
                                <SecondaryButton
                                    width={["142px", "auto", "272px"]}
                                    height="100%"
                                    backgroundColor="transparent"
                                    borderColor={theme.colours.hpPrimaryPurple.hex}
                                    color={theme.colours.hpPrimaryPurple.hex}
                                    onClick={() => history.push("/find-health-stations")}
                                    p={["8px 11px 11px 11px", "4px 11px 7px 11px"]}
                                    fontSize={["15px"]}
                                >
                                    {t("members_portal_web.views.recommendations.empty.find_station")}
                                </SecondaryButton>
                            )}
                        </Flex>
                    </Box>
                </Flex>
            </Card>
        </>
    );
};

EmptyState.propTypes = {
    history: PropTypes.object,
    theme: PropTypes.object,
    gender: PropTypes.string
};

export default EmptyState;
